import { ApiError } from './api';

/** What to tell an admin about an error; permission errors name the missing permission. */
export function friendlyMessage(error: unknown): string {
  if (error instanceof ApiError && error.status === 403 && error.code === 'auth.forbidden') {
    const perm = error.details?.permission;
    return `You don't have permission to do this${typeof perm === 'string' ? ` (needs ${perm})` : ''}. Ask an owner to grant it.`;
  }
  return error instanceof Error ? error.message : 'Something went wrong';
}
